import React from 'react'
import SkeletonBlock from './SkeletonBlock'
import SkeletonText from './SkeletonText'
import SkeletonAvatar from './SkeletonAvatar'

/**
 * Friends page placeholder: top button row, segmented tab bar,
 * and a list of friend rows.
 */
function FriendsSkeleton() {
  return (
    <div className="min-h-screen bg-app">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* Page button row */}
        <div className="flex flex-row items-center sm:justify-end gap-3">
          <SkeletonBlock className="flex-1 sm:flex-none sm:w-36 h-11 rounded-lg" />
          <SkeletonBlock className="flex-1 sm:flex-none sm:w-36 h-11 rounded-lg" />
        </div>
        {/* Segmented tabs */}
        <div className="flex space-x-1 bg-surface rounded-lg p-1">
          {[0, 1, 2].map((i) => (
            <SkeletonBlock key={i} className="flex-1 h-11 rounded-md" />
          ))}
        </div>
        {/* Friend list rows */}
        <div className="space-y-3">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className="bg-card border border-border-subtle rounded-lg p-4 flex items-center justify-between"
            >
              <div className="flex items-center space-x-3">
                <SkeletonAvatar size="w-10 h-10" />
                <div className="space-y-2">
                  <SkeletonText className="w-32 h-3.5" />
                  <SkeletonText className="w-44 h-3" />
                </div>
              </div>
              <SkeletonBlock className="w-8 h-8 rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FriendsSkeleton
